export const SETTINGS = {
    MNG_URL: process.env.REACT_APP_API_MNG_URL!,
    BASE_URL: process.env.REACT_APP_API_BASE_URL!,
    KRAFTON_URL: process.env.REACT_KRAFTON_URL!, // env 개발, 운영 분리
    STORAGE_URL: process.env.REACT_APP_STORE_CDN_URL!,
    QR_URL: process.env.REACT_APP_ROBOT_QR_URL!,
}

export type SettingsValueProps = {
    themeStretch: boolean;
    themeMode: 'light' | 'dark';
    themeDirection: 'rtl' | 'ltr';
    themeContrast: 'default' | 'bold';
    themeLayout: 'vertical' | 'horizontal' | 'mini';
    themeColorPresets: 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red';
};

export type SettingsContextProps = SettingsValueProps & {
    // Update
    onUpdate: (name: string, value: string | boolean) => void;
    // Direction by lang
    onChangeDirectionByLang: (lang: string) => void;
    // Reset
    canReset: boolean;
    onReset: VoidFunction;
    // Drawer
    open: boolean;
    onToggle: VoidFunction;
    onClose: VoidFunction;
};

